// Safari < 15.4 (iOS 15.3, macOS Safari 15.3 and older) lacks crypto.randomUUID,
// which CreateTicket calls for its idempotency key. myFoncia clients still browse on
// those versions; crypto.getRandomValues is available from Safari 11.
export function polyfillCryptoRandomUuid(): void {
  const legacyCrypto: LegacyCrypto = crypto;
  if (legacyCrypto.randomUUID) {
    return;
  }

  Object.defineProperty(crypto, "randomUUID", {
    configurable: true,
    writable: true,
    value: function randomUUID() {
      const hex = Array.from(
        crypto.getRandomValues(new Uint8Array(16)),
        (byte) => byte.toString(16).padStart(2, "0"),
      ).join("");
      const variant = (
        (Number.parseInt(hex.charAt(16), 16) & 0x3) |
        0x8
      ).toString(16);

      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-4${hex.slice(13, 16)}-${variant}${hex.slice(17, 20)}-${hex.slice(20, 32)}`;
    },
  });
}

type LegacyCrypto = Pick<Crypto, "getRandomValues"> &
  Partial<Pick<Crypto, "randomUUID">>;
